// extracted by mini-css-extract-plugin
export var infoWrapper = "styles-module--infoWrapper--4Je9L";
export var imageWrapper = "styles-module--imageWrapper--StjO5";
export var image = "styles-module--image--5hnpw";
export var titleWrapper = "styles-module--titleWrapper--e+4ne";
export var smallCaps = "styles-module--smallCaps--NSnzP";
export var title = "styles-module--title--nkdb2";
export var contentContainer = "styles-module--contentContainer--4g4el";